export const environment = {
  production: false,
  apiUrl: 'https://staging.navigandi.com.br',
};
